import { Checkmark, CrossCircle } from '@creditornot/cb-icons';
import { colors } from '@creditornot/cb-ingredients';
import React from 'react';
import styled, { css } from 'styled-components';

import LoadingPendingFlowerSpinner from 'common/components/icons/LoadingPendingFlowerSpinner';
import { Typography } from 'common/typography';

export type MetricLabelVariant = 'success' | 'alert' | 'error';

type MetricLabelProps = {
  text: string;
  variant: MetricLabelVariant;
};

const MetricLabelContainer = styled.div<{ variant: MetricLabelProps['variant'] }>`
  display: inline-flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;

  ${({ variant }) => {
    switch (variant) {
      case 'success':
        return `
                background-color: ${colors.lime8};
                color: ${colors.lime100};
                fill: ${colors.lime100};
            `;
      case 'alert':
        return `
                background-color: ${colors.banana8};
                color: ${colors.banana100};;
                fill: ${colors.banana100};;
            `;
      case 'error':
        return `
                background-color: ${colors.strawberry8};
                color: ${colors.strawberry100};
                fill: ${colors.strawberry100};
            `;
    }
  }};
`;

const MetricLabelText = styled(Typography.Body1)`
  text-transform: uppercase;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  display: table-cell;
`;

const iconStyle = css`
  width: 12px;
  height: 12px;
`;

const CheckmarkIcon = styled(Checkmark)`
  ${iconStyle}
`;

const SpinnerIcon = styled(LoadingPendingFlowerSpinner)`
  ${iconStyle}
`;

const CrossCircleIcon = styled(CrossCircle)`
  ${iconStyle}
`;

export const MetricLabel = ({ text, variant }: MetricLabelProps) => {
  return (
    <MetricLabelContainer variant={variant}>
      <MetricLabelText as="div">{text}</MetricLabelText>
      {variant === 'success' && <CheckmarkIcon />}
      {variant === 'alert' && <SpinnerIcon />}
      {variant === 'error' && <CrossCircleIcon />}
    </MetricLabelContainer>
  );
};
